import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import AppLayout, { Card } from "../components/Layout";
import EventForm from "../components/EventForm";
import httpClient from "../axios";
import { notifyError, notifySuccess } from "../helper";

const CreateEvent = () => {
	const navigate = useNavigate();
	const http = React.useMemo(() => httpClient(), []);
	const [loading, setLoading] = React.useState(false);

	const onSubmit = (payload) => {
		setLoading(true);
		http
			.post("/events", payload)
			.then((response) => {
				const event = response.data.data;
				notifySuccess("Event created", "Now add the contacts taking part.");
				navigate(`/event-mode?id=${event.id}&name=${encodeURIComponent(event.name)}`);
			})
			.catch((error) => notifyError(error, "Could not create the event"))
			.finally(() => setLoading(false));
	};

	return (
		<AppLayout title="Add event" subtitle="Create the event first, then add its contacts." narrow>
			<Card>
				<EventForm onSubmit={onSubmit} loading={loading} extra={<Button onClick={() => navigate("/events")}>Cancel</Button>} />
			</Card>
		</AppLayout>
	);
};

export default CreateEvent;
